import { Component, OnInit, Input, OnChanges, HostListener, ElementRef, OnDestroy } from '@angular/core';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { CatalogsService } from 'src/app/services/catalogs-services/catalogs-services/catalogs.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-catalogs-catalog-info-card',
  templateUrl: './catalogs-catalog-info-card.component.html',
  styleUrls: ['./catalogs-catalog-info-card.component.scss']
})
export class CatalogsCatalogInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() catalog;
  centerList;
  editingLocked;
  updateCatalogInfoSubscription;
  basicDataForm = new FormGroup({
    active: new FormControl({ value: null, disabled: true }),
    name: new FormControl({ value: null, disabled: true }, Validators.required),
    position: new FormControl({ value: null, disabled: true }, Validators.required),
    backgroundColor: new FormControl({ value: '#000000', disabled: true }),
    textColor: new FormControl({ value: '#000000', disabled: true })
  });

  constructor(private userStorageService: UserStorageService,
              private catalogsService: CatalogsService,
              private snackbarService: SnackBarService,
              private eRef: ElementRef) {
                this.editingLocked = true;
              }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
  }

  ngOnChanges() {
    if (this.catalog) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.catalog && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
        this.lockEdition();
      }
    }
  }

  public submitForm() {
    const validation = this.validateForm();
    if (validation) {
      this.updateCatalogInfoSubscription = this.catalogsService.updateCatalogInfo(this.catalog.InternalId, this.basicDataForm).subscribe(
        (res) => {
          this.editingLocked = true;
          this.snackbarService.open('catalogs-page.snackbar messages.update catalog success', 'success');
          this.catalogsService.refreshCatalog();
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
          this.catalogsService.refreshCatalog();
        }
      );
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'catalogs-page.snackbar messages.name catalog error';
    } else if (!this.basicDataForm.get('position').valid) {
      return 'catalogs-page.snackbar messages.position catalog error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      active: this.catalog.Active,
      name: this.catalog.Description,
      position: this.catalog.Ordering,
      backgroundColor: this.catalog.BackgroundColor,
      textColor: this.catalog.TextColor
    });
  }

  public unlockEdition() {
    this.basicDataForm.get('active').enable();
    this.basicDataForm.get('name').enable();
    this.basicDataForm.get('backgroundColor').enable();
    this.basicDataForm.get('textColor').enable();
    this.basicDataForm.get('position').enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.get('active').disable();
    this.basicDataForm.get('name').disable();
    this.basicDataForm.get('backgroundColor').disable();
    this.basicDataForm.get('textColor').disable();
    this.basicDataForm.get('position').disable();
    this.editingLocked = true;
  }

  ngOnDestroy() {
    if (this.updateCatalogInfoSubscription) { this.updateCatalogInfoSubscription.unsubscribe(); }
  }
}
